const DragWrapper = ({
  children,
  dragData,
  onDragStart,
  onDragEnd,
  // key,
  className,
  title,
  icon,
  value
}) => {

  const handleDragStart = (e) => {
    e.dataTransfer.setData('application/json', JSON.stringify(dragData));
    onDragStart && onDragStart(dragData);
  };

  const handleDragEnd = () => {
    onDragEnd && onDragEnd(dragData);
  };

  return (
    <div
      draggable
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      style={{ cursor: 'grab' }}
      // key={key}
      className={className}
      title={title}
    >
      {icon}
      {value}
    </div>
  );
};

export default DragWrapper